export const CURRENT_USER_START='CURRENT_USER_START';
export const CURRENT_USER_SUCCESS='CURRENT_USER_SUCCESS';
export const CURRENT_USER_FAIL='CURRENT_USER_FAIL';